module.exports = "http://cdn.realive.com.ua/src/views/games/other/images/maps/mafia1.png";